import { Autocomplete, MenuItem, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { AD_GENDERS } from "./marketingFormat";
import { useInterestSearch } from "./useMarketing";

const SEARCH_DELAY_MS = 300;

function InterestPicker({ connectionId, value, onChange }) {
  const [text, setText] = useState("");
  const [debounced, setDebounced] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(text), SEARCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, [text]);
  const search = useInterestSearch(connectionId, debounced);

  return (
    <Autocomplete
      multiple
      size="small"
      options={search.data || []}
      value={value}
      loading={search.isFetching}
      filterOptions={(options) => options}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      onChange={(_, next) => onChange(next)}
      onInputChange={(_, next, reason) => reason === "input" && setText(next)}
      noOptionsText={text.trim().length < 2 ? "Type to search interests" : "No interests found"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Interests (optional)"
          helperText="People interested in any of these. Leave empty for no interest targeting."
        />
      )}
    />
  );
}

export default function AdvancedOptions({ form, connectionId, currency }) {
  const { fields, set } = form;
  return (
    <div className="space-y-3 rounded border border-app-border p-3">
      <p className="text-sm font-medium">Audience and bidding</p>
      <div className="grid grid-cols-2 gap-3">
        <TextField
          select
          label="Gender"
          value={fields.gender}
          onChange={(e) => set("gender")(e.target.value)}
          size="small"
        >
          {AD_GENDERS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label={`Cost cap per result${currency ? ` (${currency})` : ""} (optional)`}
          value={fields.costCap}
          onChange={(e) => set("costCap")(e.target.value)}
          size="small"
          error={!form.costCapValid}
          helperText="Meta aims to keep the average cost per result at or under this"
        />
      </div>
      <InterestPicker
        connectionId={connectionId}
        value={fields.interests}
        onChange={set("interests")}
      />
    </div>
  );
}
